import { render } from "./ProjectArea.vue?vue&type=template&id=b7636c96&ts=true"
import script from "./ProjectArea.vue?vue&type=script&lang=ts"
export * from "./ProjectArea.vue?vue&type=script&lang=ts"

import "./ProjectArea.vue?vue&type=style&index=0&id=b7636c96&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__